import { render, staticRenderFns } from "./PaymentReceivedCreate.vue?vue&type=template&id=0571bbce"
import script from "./PaymentReceivedCreate.vue?vue&type=script&lang=js"
export * from "./PaymentReceivedCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports